import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  WebhookGetBody,
  WebhookParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  webhookUuid: string
  params?: WebhookParams
  onSuccess?: (webhook: WebhookGetBody) => void
  onError?: (error: Error) => void
  children?: (webhook: WebhookGetBody) => ReactElement
}

const GetWebhookRequest = ({
  webhookUuid,
  params,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/webhooks/${webhookUuid}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetWebhookRequest
